// ABOUTME: Merges a client's desired layout into the current server document by id.
// ABOUTME: Lets reorder and column changes run as a transaction instead of a blind replace.

import type { DashboardItem } from "../services/dashboardService";

export interface LayoutMergeResult {
  items: DashboardItem[];
  /** False when every position already matched and no write is needed. */
  changed: boolean;
}

/**
 * Applies the positions (`col`, `order`) from `desired` onto `current`.
 *
 * Drag-and-drop and column changes used to write the client's whole list over
 * the document. If another device had added a link in the meantime, that link
 * was not in the client's list and the write deleted it. Merging by id keeps
 * anything the client didn't know about, and ignores anything the client
 * still had that the server has since removed.
 *
 * Only positions move. Edits to other fields go through updateDashboardItem.
 */
export function mergeLayout(current: DashboardItem[], desired: DashboardItem[]): LayoutMergeResult {
  const wanted = new Map<string, { col: number; order: number }>();
  for (const item of desired) {
    if (typeof item.col === "number" && typeof item.order === "number") {
      wanted.set(item.id, { col: item.col, order: item.order });
    }
  }

  let changed = false;
  const items = current.map((item) => {
    const pos = wanted.get(item.id);
    if (!pos) return item;
    if (item.col === pos.col && item.order === pos.order) return item;
    changed = true;
    return { ...item, col: pos.col, order: pos.order };
  });

  return { items, changed };
}
